<div class="modal-header color-primario-fondo text-white">
    <h4 class="modal-title">Cargando</h4>
    <!-- <button type="button" class="btn btn-primary color-secundario-fondo" aria-label="Close" (click)="onClickDismiss($event, 'Modal cerrado')">Cerrar</button> -->
</div>
<div class="modal-body text-center">
    <p class="py-3">Cargando, por favor espere..</p>
    <img src="assets/precarga/precarga-usco.gif" alt="precarga-usco.gif">
</div>